import { apiClient } from './apiClient';
import {
    AdminUser,
    AdminUserPermission,
    CreateAdminUserRequest,
    UpdateAdminUserRequest,
    AvailableSuperAdminModule
} from '../types';

interface AdminUserApiResponse<T> {
    success: boolean;
    message?: string;
    data: T;
}

export const adminUserService = {
    /**
     * Get list of available super admin modules
     */
    async getAvailableModules(): Promise<AvailableSuperAdminModule[]> {
        const response = await apiClient.get<AdminUserApiResponse<AvailableSuperAdminModule[]>>('/super-admin/available-modules');
        return response.data || [];
    },

    /**
     * Get all admin users
     */
    async getAllAdminUsers(): Promise<AdminUser[]> {
        const response = await apiClient.get<AdminUserApiResponse<AdminUser[]>>('/super-admin/admin-users');
        return response.data || [];
    },

    /**
     * Get a specific admin user by ID
     */
    async getAdminUser(id: number): Promise<AdminUser> {
        const response = await apiClient.get<AdminUserApiResponse<AdminUser>>(`/super-admin/admin-users/${id}`);
        return response.data;
    },

    /**
     * Create a new admin user
     */
    async createAdminUser(data: CreateAdminUserRequest): Promise<AdminUser> {
        const response = await apiClient.post<AdminUserApiResponse<AdminUser>>('/super-admin/admin-users', data);
        return response.data;
    },

    /**
     * Update an existing admin user
     */
    async updateAdminUser(id: number, data: UpdateAdminUserRequest): Promise<AdminUser> {
        const response = await apiClient.put<AdminUserApiResponse<AdminUser>>(`/super-admin/admin-users/${id}`, data);
        return response.data;
    },

    /**
     * Update admin user permissions
     */
    async updatePermissions(id: number, permissions: AdminUserPermission[]): Promise<{ permissions: AdminUserPermission[] }> {
        const response = await apiClient.put<AdminUserApiResponse<{ permissions: AdminUserPermission[] }>>
            (`/super-admin/admin-users/${id}/permissions`, { permissions });
        return response.data;
    },

    /**
     * Delete an admin user
     */
    async deleteAdminUser(id: number): Promise<void> {
        await apiClient.delete(`/super-admin/admin-users/${id}`);
    },
};

export default adminUserService;
